export default __webpack_public_path__ + "static/media/undraw_electricity_k2ft.5218e18a.png";